const PATH = {
  HOME: '/',
  ALUMNI_LIST: '/alumnilist',
  FAMILY_HOME_LIST: '/familyhomelist',
  SENIOR_LIST: '/seniorlist',
  ABOUT_ME: 'student/aboutme',
  FILE_HOSTING: '/file-hosting',
  RESOURCES: '/resources',
  SENIOR_PLANNER: '/seniorplanner',
  AWARD_PAYMENT_REQUESTS: '/summary-award-payment-requests',
  AWARD_PAYMENT_REQUEST: '/award-payment-request',
  AWARD_PAYMENT_RESPONSE: '/award-payment-response',
  SENIOR_PLAN_DETAILS: (userId) => `seniorplan/details/${userId}`,
};

export default PATH;
